// GetOrdersByRegion.js
const GetOrdersByRegion = async () => {
  let userRegion = JSON.parse(localStorage.getItem("user")).region;

  let response = await fetch(
    `${process.env.REACT_APP_API_URL}/Orders/GetOrderByRegion/${userRegion}`
  ).catch((err) => {
    return [];
  });
  return response.status === 200 ? await response.json() : [];
};

export default GetOrdersByRegion;
